import axios from "axios";

const createApiInstance = (isMultipart = false) => {
    const ServerAddress = import.meta.env.VITE_SERVER_ADDRESS;

    const instance = axios.create({
        baseURL: `${ServerAddress}/api/apps`,
        withCredentials: true,
        withXSRFToken: true,
        xsrfCookieName: "XSRF-TOKEN",
        xsrfHeaderName: "X-XSRF-TOKEN",
        headers: {
            "Content-Type": isMultipart
                ? "multipart/form-data"
                : "application/json",
            Accept: "application/json",
            "ngrok-skip-browser-warning": "true",
        },
    });

    // Tambahkan interceptor untuk menangani session expired / unauthenticated
    instance.interceptors.response.use(
        (response) => response,
        (error) => {
            if (
                error.response &&
                (error.response.status === 401 || error.response.status === 419)
            ) {
                // Hapus data lokal karena sesi di backend sudah hangus
                localStorage.removeItem("user");

                // Dispatch event agar AuthContext bisa update state tanpa hard redirect
                window.dispatchEvent(new Event("session-expired"));
            }
            return Promise.reject(error);
        },
    );

    return instance;
};

export const api = createApiInstance(false);
export const mpApi = createApiInstance(true);
